<template>
  <div id="administrador">
    <!-- <div class="separador text-center mt-5 py-5" data-aos="fade-up" data-aos-delay="600">
      <p class="otrafont fXG electrico">Cuestionarios Registrados</p>
    </div> -->

    <HeaderAdmin></HeaderAdmin>

    <div class="pt4">
      <!-- <div class="row pb-5">
        <div class="col-12 otrafont fpR electrico">Semana 1</div>
      </div>-->

      <!-- <b-sidebar id="sidebar-1" title="Menú" shadow>
        <div class="px-3 py-2">
          <a class="float-right fpR pointer" @click="logout"> Cerrar Sesión </a>
        </div>
      </b-sidebar> -->

      <div class="row m-0">
        <div class="col-3">
          <div class="row">
            <div class="col-12">
              <SidebarAdmin></SidebarAdmin>
            </div>
          </div>
        </div>

        <div class="col-9 bgazuladmin bgazulgradiente p-5">
          <div class="row p-5" data-aos="fade-left" data-aos-delay="200">
            <div class="col-12 pb-5">
              <h2 class="blanco bold pb-3">Datos del Grupo</h2>
              <form
                action=""
                class="formadmin blanco fpXG2"
                @submit="submitForm($event)"
              >
                <label>
                  <span>Plantel</span>
                  <select v-model="form.plantel">
                    <option value="">Seleccionar</option>
                    <option :value="plantel.id" v-for="(plantel, index) of planteles" :key="index">{{plantel.nombre}}</option>
                  </select>
                </label>
                <label>
                  <span>Grupo</span>
                  <input type="text" v-model="form.grupo" required />
                </label>
                <label>
                  <span>ID Grupo</span>
                  <input type="text" v-model="form.id_grupo" required />
                </label>
                <label>
                  <span>Administrador</span>
                  <select v-model="form.administrador">
                    <option value="">Seleccionar</option>
                    <option :value="admin.nombre" v-for="(admin, index) of docentes" :key="index">{{admin.nombre}} {{admin.apellidos}}</option>
                  </select>
                </label>
                <label class="text-right py-5">
                  <button type="submit">CREAR GRUPO</button>
                </label>
              </form>
            </div>

            <div class="col-12 pb-5">
              <h2 class="blanco bold pb-3">Grupos</h2>
              <div class="row">
                <div class="col-12 admintabla">
                  <v-client-table
                    :columns="columns"
                    v-model="grupos"
                    :options="options"
                  >
                    <a
                      slot="uri"
                      slot-scope="props"
                      target="_blank"
                      :href="props.row.uri"
                      class="glyphicon glyphicon-eye-open"
                      >Ver</a
                    >

                    <div
                      slot="name"
                      slot-scope="{
                        row,
                        update,
                        setEditing,
                        isEditing,
                        revertValue,
                      }"
                    >
                      <span @click="setEditing(true)" v-if="!isEditing()">
                        <a>{{ row.name }}</a>
                      </span>
                      <span v-else>
                        <input type="text" v-model="row.name" />
                        <button
                          type="button"
                          class="btn btn-info btn-xs"
                          @click="
                            update(row.name);
                            setEditing(false);
                          "
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          class="btn btn-default btn-xs"
                          @click="
                            revertValue();
                            setEditing(false);
                          "
                        >
                          Cancel
                        </button>
                      </span>
                    </div>
                  </v-client-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Glyphicons></Glyphicons>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SidebarAdmin from "@/components/SidebarAdmin";
import HeaderAdmin from "@/components/HeaderAdmin";

import * as fb from "../../firebase";
import * as moment from "moment";
import { misionesCollection, usersCollection, docentesCollection, } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    SidebarAdmin,
    HeaderAdmin,
    Glyphicons,
  },
  data() {
    return {
      form: {
        plantel: "",
        grupo: "",
        id_grupo: "",
        administrador: "",
      },
      formCargar: {
        file: "",
      },
      formFacturacion: {
        rfc: "",
        nombre: "",
        email: "",
        telefono: "",
        direccion: "",
      },
      columns: ["plantel", "grupo", "id_grupo", "administrador"],
      data: null,
      options: {
        perPage: 100,
        headings: {
          plantel: "Plantel",
          grupo: "Grupo",
          id_grupo: "ID Grupo",
          administrador: "Administrador",
        },
        editableColumns: [],
        sortable: [],
        texts: {
          count:
            "Mostrando {from} hasta {to} de {count} registros|{count} registros|Un registro",
          first: "Primero",
          last: "Último",
          filter: "Filtro:",
          filterPlaceholder: "Búsqueda",
          limit: "Registros:",
          page: "Página:",
          noResults: "No hay datos.",
          noRequest: "Por favor selecciona una opción para filtrar resultados",
          filterBy: "Filtrar por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
      planteles: [],
      grupos: [],
      docentes: [],
      initiated: false
    };
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
    institucionID(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });


    this.init();
  
  },
  methods: {
    init() {
      if (
        this.userProfile == null ||
        this.institucionID == null ||
        this.initiated == true
      ) {
        return;
      }

      this.initiated = true;

      this.getDocentes();
      this.getPlanteles();
      this.getGrupos();
    },
    async submitForm(e) {
      e.preventDefault();

      this.form.institucion_id = this.institucionID;
      if (this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1") {
        this.form.institucion_id = this.userProfile.institucion;
      }

      let res = await this.$store.dispatch("agregaGrupo", this.form);

      if (res === true) {
        window.location.reload();
      } else {
        swal.fire(
          "Oops",
          "Hubo un problema, por favor intenta de nuevo.",
          "warning"
        );
      }
    },
    async getDocentes() {
      this.$store.dispatch("showLoader", true);

      let institucion = {
        institucion_id: this.institucionID,
        nombre: this.userProfile.nombre,
        disponibles: this.userProfile.disponibles,
      };
      if(this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1"){
        institucion.institucion_id = this.userProfile.institucion; 
      }

      const docs = await docentesCollection
        .where("institucion_id", "==", institucion.institucion_id)
        .get();

      this.docentes = [];
      let thes = this;
      docs.forEach((doc) => {
        let docente = doc.data();
        docente.id = doc.id;
        thes.docentes.push(docente);
      });
      try {
        this.docentes = this.docentes.sort(this.custom_sort);
      } catch (e) {
        //
      }

      console.log({ docentes: this.docentes });

      this.$store.dispatch("showLoader", false);

      //this.setResumen();
    },
    async getPlanteles() {
      let institucion = {
        institucion_id: this.institucionID,
      };
      if (this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1") {
        institucion.institucion_id = this.userProfile.institucion;
      }

      this.planteles = await this.$store.dispatch("getPlanteles", institucion);
      console.log({planteles: this.planteles});

      //this.expandeGrupos();
    },
    async getGrupos() {
      let institucion = {
        institucion_id: this.institucionID,
      };
      if (this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1") {
        institucion.institucion_id = this.userProfile.institucion;
      }

      this.grupos = await this.$store.dispatch("getGrupos", institucion);
      console.log({grupos: this.grupos});

      //this.expandeGrupos();
    },
    logout() {
      this.$store.dispatch("logoutReportes");
    },
  },
};
</script>
